import Disclamer from '../../assets/pdf/Disclamer.pdf'
import PDFViewer from '../../shared/PDFViewer';



function Disclaimer(props:any) {
    return <PDFViewer pdf={Disclamer} />;
}

export default Disclaimer;